import FingerprintJS from '@fingerprintjs/fingerprintjs'


// Initialize the agent at application startup
const fpPromise = FingerprintJS.load()

export const getDeviceFingerprint = async () => {
 
  
  try {
   
    const fp = await fpPromise
    
    
  
    const result = await fp.get()
    
    
    const visitorId = result.visitorId
    
    
   
    return visitorId
  } catch (error) {
    console.error('❌ DeviceFingerprint: Error generating fingerprint:', error);
    console.error('❌ DeviceFingerprint: Error details:', error.message);
    return null
  }
} 